"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _postmsgRpc = require("postmsg-rpc");

var _rpcUtils = require("rpc-utils");

var _didProviderProxy = _interopRequireDefault(require("./didProviderProxy"));

var CONNECT_IFRAME_URL = process.env.CONNECT_IFRAME_URL || 'https://app.3idconnect.org';
var HIDE_IFRAME_STYLE = 'position: fixed; width:0; height:0; border:0; border:none !important';
var DISPLAY_IFRAME_STYLE = 'border:none border:0; z-index: 500; position: fixed; max-width: 100%;';
var IFRAME_TOP = "top: 10px; right: 10px";
var IFRAME_BOTTOM = "bottom: 0px; left: 0px;"; // @ts-ignore

var hide = function hide(iframe) {
  return function () {
    return iframe.style = HIDE_IFRAME_STYLE;
  };
};

var display = function display(iframe) {
  return function () {
    var mobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '245px';
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '440px';
    // @ts-ignore
    iframe.style = "".concat(DISPLAY_IFRAME_STYLE, " width: ").concat(width, "; height: ").concat(height, "; ").concat(mobile ? IFRAME_BOTTOM : IFRAME_TOP);
  };
};

var createRPCProvider = function createRPCProvider(postMessage) {
  var sendRPC = (0, _postmsgRpc.caller)('send', {
    postMessage: postMessage
  });
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    send: function () {
      var _send = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(req) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = JSON;
                _context.next = 3;
                return sendRPC(req);

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", _context.t0.parse.call(_context.t0, _context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  };
};
/**
 *  ThreeIdConnect provides interface for loading and instantiating IDW iframe,
 *  and provides a 3ID provider interface to send requests to iframe. Acts like
 *  rpc client.
 */


var ThreeIdConnect = /*#__PURE__*/function () {
  /**
   *  Creates ThreeIdConnect. Create and loads iframe. Should be instantiated
   *  on page load.
   *
   * @param     {String}    iframeUrl   iframe url, defaults to 3id-connect iframe service
   */
  function ThreeIdConnect(iframeUrl) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ThreeIdConnect);
    (0, _defineProperty2["default"])(this, "iframe", void 0);
    (0, _defineProperty2["default"])(this, "iframeLoadedPromise", void 0);
    (0, _defineProperty2["default"])(this, "postMessage", void 0);
    (0, _defineProperty2["default"])(this, "RPCProvider", void 0);
    (0, _defineProperty2["default"])(this, "RPCClient", void 0);
    (0, _defineProperty2["default"])(this, "authProvider", void 0);
    (0, _defineProperty2["default"])(this, "accountId", void 0);
    (0, _defineProperty2["default"])(this, "_connected", false);

    if (typeof window === 'undefined' || typeof document === 'undefined') {
      throw new Error('ThreeIdConnect not supported in this enviroment');
    }

    this.iframe = document.createElement('iframe');
    this.iframe.src = iframeUrl || CONNECT_IFRAME_URL; // @ts-ignore

    this.iframe.style = HIDE_IFRAME_STYLE; // @ts-ignore

    this.iframe.allowTransparency = true; // @ts-ignore

    this.iframe.frameBorder = 0;
    this.iframeLoadedPromise = new Promise(function (resolve) {
      _this.iframe.onload = function () {
        resolve();
      };
    });
    document.body.appendChild(this.iframe);
  }

  (0, _createClass2["default"])(ThreeIdConnect, [{
    key: "connect",
    value: function () {
      var _connect = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(provider) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // TODO DETECTION ON CAP10,  consume auth provider or other providers
                // just consume any providers and then create auth provider here, at very least has to support 3box
                if (provider) {
                  this.setAuthProvider(provider);
                }

                _context2.next = 3;
                return this.iframeLoadedPromise;

              case 3:
                this.postMessage = this.iframe.contentWindow.postMessage.bind(this.iframe.contentWindow);

                this._registerDisplayHandlers();

                this._registerAuthHandlers();

                this.RPCProvider = createRPCProvider(this.postMessage);
                this.RPCClient = new _rpcUtils.RPCClient(this.RPCProvider);
                this._connected = true;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function connect(_x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "setAuthProvider",
    value: function setAuthProvider(authProvider) {
      this.authProvider = authProvider;
      this.accountId = this.authProvider.accountId;
    }
  }, {
    key: "_registerDisplayHandlers",

    /**
     *  Handlers to consumer message to hide or display iframe
     *
     * @private
     */
    value: function _registerDisplayHandlers() {
      (0, _postmsgRpc.expose)('display', display(this.iframe), {
        postMessage: this.postMessage
      });
      (0, _postmsgRpc.expose)('hide', hide(this.iframe), {
        postMessage: this.postMessage
      });
    }
    /**
     *  Handlers to consume messages for authProvider
     *
     * @private
     */

  }, {
    key: "_registerAuthHandlers",
    value: function _registerAuthHandlers() {
      (0, _postmsgRpc.expose)('authenticate', this._authenticate.bind(this), {
        postMessage: this.postMessage
      });
      (0, _postmsgRpc.expose)('createLink', this._createLink.bind(this), {
        postMessage: this.postMessage
      });
    }
  }, {
    key: "_authenticate",
    value: function () {
      var _authenticate2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(message, accountId) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.authProvider.authenticate(message, accountId);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _authenticate(_x3, _x4) {
        return _authenticate2.apply(this, arguments);
      }

      return _authenticate;
    }()
  }, {
    key: "_createLink",
    value: function () {
      var _createLink2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(did, accountId) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.authProvider.createLink(did, accountId));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _createLink(_x5, _x6) {
        return _createLink2.apply(this, arguments);
      }

      return _createLink;
    }()
  }, {
    key: "accounts",
    value: function () {
      var _accounts = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.RPCClient.request('3id_accounts');

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function accounts() {
        return _accounts.apply(this, arguments);
      }

      return accounts;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var params;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.authProvider) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('setAuthProvder required');

              case 2:
                params = {
                  accountId: this.accountId
                };
                return _context6.abrupt("return", this.RPCClient.request('3id_createAccount', params));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createAccount() {
        return _createAccount.apply(this, arguments);
      }

      return createAccount;
    }() // support priv links in future, auth link, link auth

  }, {
    key: "addAuthAndLink",
    value: function () {
      var _addAuthAndLink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(baseDid) {
        var params;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.authProvider) {
                  _context7.next = 2;
                  break;
                }

                throw new Error('setAuthProvder required');

              case 2:
                params = {
                  baseDid: baseDid,
                  accountId: this.accountId
                };
                return _context7.abrupt("return", this.RPCClient.request('3id_addAuthAndLink', params));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addAuthAndLink(_x7) {
        return _addAuthAndLink.apply(this, arguments);
      }

      return addAuthAndLink;
    }()
    /**
     *  Returns a DID provider, which can send and receive messages from iframe
     *
     * @return    {DIDProviderProxy}     A DID provider
     */

  }, {
    key: "getDidProvider",
    value: function getDidProvider() {
      if (!this.authProvider) throw new Error('setAuthProvder required');
      return new _didProviderProxy["default"](this.RPCProvider, this.authProvider.accountId);
    }
  }, {
    key: "connected",
    get: function get() {
      return this._connected;
    }
  }]);
  return ThreeIdConnect;
}();

var _default = ThreeIdConnect;
exports["default"] = _default;